var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTj = function SvgTj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M1.19 6.782A11.952 11.952 0 0 0 0 11.999c0 1.87.428 3.64 1.19 5.217L12 18.26l10.81-1.044A11.953 11.953 0 0 0 24 12c0-1.87-.428-3.64-1.19-5.217L12 5.738 1.19 6.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M1.191 17.218A12 12 0 0 0 12.001 24a12 12 0 0 0 10.808-6.782H1.191Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M1.191 6.782H22.81A12 12 0 0 0 12-.001 12 12 0 0 0 1.191 6.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.913 15.132h4.174v-1.774l-.835.417L12 12.523l-1.252 1.252-.835-.417v1.774ZM7.525 13.044l.194.598h.629l-.509.37.195.597-.509-.37-.509.37.195-.598-.509-.37h.629l.194-.597ZM8.128 10.958l.194.598h.628l-.508.37.194.597-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.597ZM9.85 9.393l.194.598h.628l-.508.37.194.597-.509-.37-.508.37.194-.598-.509-.37h.629l.194-.597ZM16.475 13.044l-.194.598h-.629l.509.37-.194.597.508-.37.509.37-.195-.598.51-.37h-.63l-.194-.597ZM15.873 10.958l-.195.598h-.628l.508.37-.194.597.509-.37.508.37-.194-.598.509-.37h-.629l-.194-.597ZM14.151 9.393l-.194.598h-.629l.509.37-.195.597.509-.37.508.37-.194-.598.509-.37h-.629l-.194-.597ZM12 8.61l.195.597h.628l-.508.37.194.598-.508-.37-.509.37.194-.598-.508-.37h.628l.195-.598Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTj;